import { CreateFinancialEntityBudgetBody } from "@project/data/dto/budget/create-financial-entity-budget.body";
import { CreateFinancialEntityBudget } from "@project/domain/models/budget/create-financial-entity-budget.model";
import { FinancialEntityBudgetFormValuesValidated } from "@project/presentation/components/budget-form/budget-form.component";
import { injectable } from "inversify";

@injectable()
export class CreateFinancialEntityBudgetMapper {
    mapFromFinancialEntityBudgetFormValues(
        financialEntityBudgetForm: FinancialEntityBudgetFormValuesValidated,
        isTemplate?: boolean,
    ): CreateFinancialEntityBudget {
        return new CreateFinancialEntityBudget(
            financialEntityBudgetForm.name,
            financialEntityBudgetForm.description,
            financialEntityBudgetForm.financialEntityId || null,
            financialEntityBudgetForm.justificationTemplateId,
            isTemplate,
            financialEntityBudgetForm.includesIndirectCosts,
        );
    }

    mapToDto(
        createFinancialEntityBudget: CreateFinancialEntityBudget,
    ): CreateFinancialEntityBudgetBody {
        return {
            name: createFinancialEntityBudget.name,
            description: createFinancialEntityBudget.description,
            finantial_entity: createFinancialEntityBudget.financialEntityId,
            justification_template:
                createFinancialEntityBudget.justificationTemplateId,
            is_template: createFinancialEntityBudget.isTemplate,
            includes_indirect_costs:
                createFinancialEntityBudget.includesIndirectCosts,
        };
    }
}
